/**
 * 👑 Super Admin Protected Route
 *
 * يمنع تحميل صفحات السوبر أدمن لمستخدم admin عادي حتى عند فتح الرابط مباشرة.
 * تبقى Firestore Rules هي حاجز الأمان النهائي للبيانات.
 */

import { Navigate, Outlet } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

import { useAuthStore } from '@application/stores/auth.store';

export function SuperAdminProtectedRoute() {
  const { user, isAuthenticated, isLoading, isHydrated } = useAuthStore();

  if (!isHydrated || isLoading) return null;
  if (!isAuthenticated || !user) return <Navigate to="/login" replace />;
  if (user.role !== 'super_admin') return <AccessDeniedScreen />;

  return <Outlet />;
}

function AccessDeniedScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <ShieldAlert className="mx-auto mb-4 h-16 w-16 text-rose-500" />
        <h1 className="text-2xl font-bold text-rose-700">
          هذه الصفحة للسوبر أدمن فقط
        </h1>
        <p className="mt-2 text-sm text-rose-600">
          حساب الأدمن العادي لا يملك صلاحية إدارة إعدادات التقويم العامة.
        </p>
      </div>
    </div>
  );
}

